import React, { Dispatch, SetStateAction } from 'react';
import styled from 'styled-components';

import { ModalContents } from './ModalContents';

interface PrivateSetModalProps {
  setOpenPrivateSetModal: Dispatch<SetStateAction<boolean>>;
  apartmentIdx: number;
}

export const PrivateSetModal = ({
  setOpenPrivateSetModal,
  apartmentIdx,
}: PrivateSetModalProps) => {
  const closeModal = () => {
    setOpenPrivateSetModal(false);
  };

  return (
    <Background onClick={closeModal}>
      <Container
        onClick={e => {
          e.stopPropagation();
        }}
      >
        <ModalContents closeModal={closeModal} apartmentIdx={apartmentIdx} />
      </Container>
    </Background>
  );
};

const Background = styled.div`
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7); /* rgba(0, 0, 0, 0.3) */
  z-index: 999;
`;

const Container = styled.div`
  padding: 10px;
  border-radius: 8px;
  background: white;
`;
